export const networks = [
  {
    networkName: "Mainnet",
    type: "mainnet"
  },
  {
    networkName: "Testnet",
    type: "testnet"
  }
];
